export default {
  //用户列表
  // customerService: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/customer-service/list.vue'));
  //   }, '/modules/customer-service/list');
  // },
  serviceBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/customer-service/service-banner.vue'));
    }, '/modules/customer-service/service-banner');
  },
  preSalingSupport: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/customer-service/presaling-support.vue'));
    }, '/modules/customer-service/presaling-support');
  },
  getStarted: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/customer-service/get-started.vue'));
    }, '/modules/customer-service/get-started');
  },
  keepRunning: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/customer-service/keep-running.vue'));
    }, '/modules/customer-service/keep-running');
  },
  futureManagement: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/customer-service/future-management.vue'));
    }, '/modules/customer-service/future-management');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/customer-service.js